import React, { useState, useEffect } from 'react';
import classes from './index.module.scss';

const InfoBoardItem = ({ header, request, deleteTrigger }) => {
  const [count, setCount] = useState();

  useEffect(() => {
    request(setCount)
  }, [deleteTrigger])

  return (
    <div className={classes.Info_Board_Item}>
      <span>
        {count}
      </span>
      <p>
        {header}
      </p>
    </div>
  )
}

export default InfoBoardItem;